import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';

export abstract class TooltipActions {
    public static showTooltip(id: number): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_TOOLTIP,
            value: id
        });
    }

    public static hideTooltip(id?: number): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.HIDE_TOOLTIP,
            value: id
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/TooltipActions.ts